import { LoanForm } from '../constants/loanForm';

/**
 * Bridge loans with "Same as Committed" checked: Apprvd Loan Amt and Bridge Funded follow Prom. Note/Com. Called when
 * Prom. Note changes or the box is checked. Returns the changes to apply.
 */
export const applySameAsCommitted = (
    form: LoanForm,
    isBridgeLoan: boolean,
    sameAsCommitted: boolean
): Pick<LoanForm, 'commitment' | 'bridgeFunded'> | undefined => {
    if (!isBridgeLoan || !sameAsCommitted) {
        return undefined;
    }
    return { commitment: form.promissoryNote, bridgeFunded: form.promissoryNote };
};
